import styled from 'styled-components';
export const ParamDescriptorWrapper = styled.div.withConfig({
  displayName: "Helpers__ParamDescriptorWrapper",
  componentId: "t9v5b9-0"
})(["width:136px;"]);